import {Routes,Route} from "react-router-dom"
import React, { useEffect } from 'react';
import "./style.scss"
import Header from './Header/Header';
import Content from './Content/Content';
import Footer from "./Footer/Footer"
import Popup from './Popup/Popup';
import Contact from './Contact/Contact'
import Address from "./Address/Address";
import Impressum from "./impressum/Impressum";
import ApplyJob from "./ApplyJob/ApplyJob";
import AboutUs from "./AboutUs/AboutUs";
import DatenSchutz from "./DatenSchutz/DatenSchutz";

function App() {

  useEffect(() => {
    window.scrollTo({top:0,behavior:'smooth'})
  },[])
  return (
    <div className="App">
      <Header/>
      
      
      {/* <Popup/> */}
      <Routes>
        <Route path='/' element={<Content/>}/>
        {/* <Route path='/kontakt' element={<Contact/>}/> */}
        <Route path='/adresse' element={<Address/>}/>
        <Route path='/impressum' element={<Impressum/>}/>
        <Route path='/datenschutzerklaerung' element={<DatenSchutz/>}/>
        <Route path='/jobs' element={<ApplyJob/>}/>
        <Route path='/aboutUs' element={<AboutUs/>}/>
      </Routes>
      <Footer/>
    </div>
  );
}

export default App;
